import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react";
import { Select, Spin } from "antd";
import { useStores } from "../../../store";
import { __ } from "../../../utils";
const ConsentRefererSelect = observer((param)=>{
    let { value, onChange } = param;
    const [selected, setSelected] = useState(value);
    const [focusedOnce, setFocusedOnce] = useState(false);
    const { consentStore } = useStores();
    const { busyReferer, referer } = consentStore;
    useEffect(()=>{
        if (focusedOnce) {
            consentStore.fetchReferer();
        }
    }, [
        focusedOnce
    ]);
    const options = useMemo(()=>{
        const groupedOptions = referer.reduce((acc, url)=>{
            try {
                const { hostname, origin } = new URL(url);
                if (!acc[hostname]) {
                    acc[hostname] = [];
                }
                acc[hostname].push({
                    label: url.substring(origin.length),
                    value: url
                });
            } catch (e) {
            // ignore
            }
            return acc;
        }, {});
        return Object.entries(groupedOptions).map((param)=>{
            let [hostname, urls] = param;
            return {
                label: hostname,
                options: urls.sort((a, b)=>a.label.localeCompare(b.label))
            };
        });
    }, [
        referer
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        showSearch: true,
        onFocus: ()=>setFocusedOnce(true),
        value: selected,
        notFoundContent: busyReferer ? /*#__PURE__*/ _jsx(Spin, {
            size: "small"
        }) : null,
        loading: busyReferer,
        allowClear: true,
        onClear: ()=>{
            setSelected(undefined);
            onChange == null ? void 0 : onChange(undefined);
        },
        dropdownAlign: {
            points: [
                "tr",
                "br"
            ]
        },
        dropdownStyle: {
            width: 500
        },
        style: {
            width: 200
        },
        placeholder: __("Filter by URL..."),
        onChange: (value)=>{
            const useValue = value || undefined;
            setSelected(useValue);
            onChange == null ? void 0 : onChange(useValue);
        },
        options: options
    });
});
export { ConsentRefererSelect };
